import React from "react";
import { PlxsButton, PlxsIcon } from "@plexlogic/plexus-ui";
import { toSentenceCase } from "../../utils/stringUtils";

interface FileInfo {
  file_name: string;
  original_filename: string;
}

interface DownloadsAndActionsProps {
  drawStatus: string;
  files: FileInfo[];
  onDownloadEntries: () => void;
  onDownloadResults: () => void;
  onDownloadCertificate: () => void;
  isLoadingEntries: boolean;
  isLoadingResults: boolean;
  isLoadingCertificate: boolean;
}

const DownloadsAndActions: React.FC<DownloadsAndActionsProps> = ({
  drawStatus,
  files,
  onDownloadEntries,
  onDownloadResults,
  onDownloadCertificate,
  isLoadingEntries,
  isLoadingResults,
  isLoadingCertificate,
}) => {
  const hasEntries = files && files.length > 0;
  const isCompleted = drawStatus === "completed";

  return (
    <div className="draw-detail-card" style={{ height: "fit-content" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "var(--plexus-space-xl)",
        }}
      >
        <PlxsIcon name="download" />
        <h3
          style={{
            margin: "0 0 0 var(--plexus-space-sm)",
            fontSize: "1.125rem",
            fontWeight: 600,
            color: "var(--plexus-color-neutral-100)",
          }}
        >
          {toSentenceCase("Downloads")}
        </h3>
      </div>

      {/* Downloads Section */}
      <div className="downloads-section">
        <div className="download-items">
          <div className="download-button-wrapper">
            <PlxsButton
              dataTestId="draw-detail-download-entries-button"
              variant="secondary"
              tone="neutral"
              label={toSentenceCase("Entries")}
              onClick={onDownloadEntries}
              isDisabled={!hasEntries || isLoadingEntries}
              isLoading={isLoadingEntries}
            />
          </div>
          
          <div className="download-button-wrapper">
            <PlxsButton
              dataTestId="draw-detail-download-results-button"
              variant="secondary"
              tone="neutral"
              label={toSentenceCase("Results")}
              onClick={onDownloadResults}
              isDisabled={!isCompleted || isLoadingResults}
              isLoading={isLoadingResults}
            />
          </div>
          
          <div className="download-button-wrapper">
            <PlxsButton
              dataTestId="draw-detail-download-certificate-button"
              variant="secondary"
              tone="neutral"
              label={toSentenceCase("Certificate")}
              onClick={onDownloadCertificate}
              isDisabled={!isCompleted || isLoadingCertificate}
              isLoading={isLoadingCertificate}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadsAndActions;
